module.exports = __webpack_public_path__ + "img/mobile_keyboard_dark.8449a376.png";